import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu"]

  connect() {
    // Close dropdown when clicking outside
    this.boundCloseOnClickOutside = this.closeOnClickOutside.bind(this)
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    this.menuTarget.classList.toggle("show")

    if (this.menuTarget.classList.contains("show")) {
      // Add click listener to close when clicking outside
      setTimeout(() => {
        document.addEventListener("click", this.boundCloseOnClickOutside)
      }, 0)
    } else {
      document.removeEventListener("click", this.boundCloseOnClickOutside)
    }
  }

  close() {
    this.menuTarget.classList.remove("show")
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  disconnect() {
    document.removeEventListener("click", this.boundCloseOnClickOutside)
  }
}
